export default class SalesFiltersViewModel {
    isActive: boolean = false;
    sale: boolean = true;
    saleType: string[] = [];
    productType: string[] = [];
    product: string[] = [];
    productOffer: string[] = [];
    productReference: string = '';
}